import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import styles from "./styles.module.css";
import { BookFreeTrialButton } from "../../commonUtils";

function TeacherCardHome({ course, width }) {
  const navigate = useNavigate();
  const [fav, setFav] = useState(false);

  if (width < 992) return null; // Only render for large screens
  if (!course || !course.userId) return null;

  const onType = course.userId.onType || {};

  const getYTVideoId = (url) => {
    if (!url) return "";
    if (url.includes("v=")) return url.split("v=")[1].split("&")[0];
    if (url.includes("youtu.be/")) return url.split("youtu.be/")[1].split("?")[0];
    return "";
  };

  const videoId = getYTVideoId(onType.videoURL?.data);
  const languageFlag = course.language?.data ? `/flags/${course.language.data.toLowerCase()}.png` : "";

  const showTeacherProfile = () => {
    localStorage.setItem("chosenCourse", JSON.stringify(course));
    navigate("/teacher-profile");
  };

  return (
    <div className={styles.card}>
      {/* Teacher Info Section */}
      <div className={styles.infoSection}>
        <div className={styles.profileSide}>
          <div className={styles.avatarWrapper} onClick={showTeacherProfile}>
            <img
              src={onType.teacherProfilePic?.data}
              alt="teacher"
              className={styles.avatar}
            />
            {languageFlag && (
              <img
                src={languageFlag}
                alt="language flag"
                className={styles.flagIcon}
              />
            )}
          </div>
          <div className={styles.priceDisplay}>
            ₹{course.price?.data || course.price}
            <span>INR/hr</span>
          </div>
        </div>

        {/* Teacher Details */}
        <div className={styles.detailsSide}>
          <div className={styles.courseBadge} onClick={showTeacherProfile}>
            {course.title?.data || course.title}
          </div>

          <h2 className={styles.teacherName} onClick={showTeacherProfile}>
            {onType.firstName?.data || onType.firstName} {onType.lastName?.data || onType.lastName}{" "}
            <i className="fas fa-certificate"></i>
          </h2>

          <div className={styles.ratingWrapper}>
            {[1, 2, 3, 4, 5].map((_, index) => (
              <i key={index} className={index < (onType.avgRating || 0) ? "fas fa-star" : "far fa-star"} />
            ))}
            <span className={styles.ratingCount}>({onType.expertise?.ratings_teacher?.length || 0})</span>
          </div>

          <div className={styles.teacherType}>
            {onType.teacherType?.data || onType.teacherType}
          </div>

          <div className={styles.statsRow}>
            <div className={styles.statItem}>
              <label>Teaches</label>
              <div className={styles.value}>
                {onType.languageTeach?.[0]?.data || onType.languageTeach?.[0] || "N/A"}
                {onType.languageTeach?.length > 1 && (
                  <span style={{ fontSize: "12px", color: '#94a3b8' }}> +{onType.languageTeach.length - 1} more</span>
                )}
              </div>
            </div>
            <div className={styles.statItem}>
              <label>Speaks</label>
              <div className={styles.value}>
                {onType.languageSpeak?.[0]?.data || onType.languageSpeak?.[0] || "N/A"}
                {onType.languageSpeak?.length > 1 && (
                  <span style={{ fontSize: "12px", color: '#94a3b8' }}> +{onType.languageSpeak.length - 1} more</span>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className={styles.actionsSection}>
          <i
            className={`${styles.favIcon} ${fav ? "fas fa-heart " + styles.favIconFilled : "far fa-heart " + styles.favIconEmpty}`}
            onClick={(e) => {
              e.stopPropagation();
              setFav(!fav);
            }}
          ></i>
          <BookFreeTrialButton course={course} />
          <button className={styles.bookCourseBtn} onClick={() => { localStorage.setItem("chosenCourse", JSON.stringify(course)); navigate("/calendar"); }}>Book Course</button>
        </div>
      </div>

      {/* Video Section */}
      <div className={styles.videoSection}>
        <div className={styles.videoHeader}>Intro Video</div>
        <div className={styles.videoFrameWrapper}>
          {videoId && (
            <iframe
              className={styles.videoFrame}
              src={`https://www.youtube.com/embed/${videoId}`}
              title="Teacher Video"
              allowFullScreen
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default TeacherCardHome;
